import $ from "jquery";
import * as Common from "../../../common/common";
import * as omnimap from "../../../../api/omnimap/omnimapActions";

export default function standart() {}

export function getAllPlannigCheckTable(key) {
  return new Promise(function (resolve, reject) {
    var model = {
      content: [
        {
          key: "algemeen-actief",
          and_or: "AND",
          values: [],
          datatype: "BOOLEAN",
        },
      ],
      definitions: [key],
      sorting: [],
    };
    let resultAllWerkPlan = omnimap.FillTableAction(
      model,
      1,
      window.$mm_management_units_token
    );
    resolve(resultAllWerkPlan);
  });
}

export function listToTree(list) {
  var map = {},
    node,
    roots = [],
    i;
  for (i = 0; i < list.length; i += 1) {
    map[list[i].id] = i;
    list[i].children = [];
  }
  for (i = 0; i < list.length; i += 1) {
    node = list[i];
    if (node.parentfolder !== "0" && node.parentfolder !== undefined) {
      list[map[node.parentfolder]].children.push(node);
    } else {
      roots.push(node);
    }
  }
  return roots;
}
function arr_diff(a1, a2) {
  var a = [],
    diff = [];

  for (var i = 0; i < a1.length; i++) {
    a[a1[i]] = true;
  }

  for (var i = 0; i < a2.length; i++) {
    if (a[a2[i]]) {
      delete a[a2[i]];
    } else {
      a[a2[i]] = true;
    }
  }

  for (var k in a) {
    diff.push(k);
  }

  return diff;
}
export async function plannigListToTree(list) {
  return new Promise(async function (resolve, reject) {
    let allTableRows = [];
    var selectedItem = [];
    var notLinkRow = [];
    var resultList = [];

    switch (window.$mm_side_menu_tree_key) {
      case "werkplannen":
        allTableRows = await getAllPlannigCheckTable(
          process.env.REACT_APP_CATALOG_WORK_PLANS
        );
        break;
      case "budget":
        allTableRows = await getAllPlannigCheckTable(
          process.env.REACT_APP_CATALOG_BUDGET
        );
        break;
      default:
        break;
    }
    var map = {},
      node,
      roots = [],
      i;
    for (i = 0; i < list.length; i += 1) {
      map[list[i].id] = i;
      list[i].children = [];
    }
    for (i = 0; i < list.length; i += 1) {
      node = list[i];

      var model = {
        content: [
          {
            key: "algemeen-actief",
            and_or: "AND",
            values: [],
            datatype: "BOOLEAN",
          },
        ],
        context: [
          {
            role: "Werkplan zit in folder",
            instance_identifiers: [node.id],
            direction: "from",
            and_or: "AND",
            start: "2020-11-09T09:56:22.986Z",
          },
        ],
        sorting: [],
        definitions: [process.env.REACT_APP_CATALOG_WORK_PLANS],
      };

      let result = await omnimap.FillTableAction(
        model,
        1,
        window.$mm_management_units_token
      );

      if (result.meta.total_found > 0) {
        result.data.forEach((item) => {
          let model = {
            children: [],
            name: item.name,
            id: item.name,
            _id: item.identification,
            isSubfolder: true,
            parentfolder: node.id,
            // rombus isActive
            //treeSymbolType: "rombus",
          };

          //? pureTree için kullanılan array
          resultList.push(model);
          node.children.push(model);
          selectedItem.push(model);
        });
      }

      if (node.parentfolder !== "0" && node.parentfolder !== undefined) {
        list[map[node.parentfolder]].children.push(node);
      } else {
        roots.push(node);
      }
    }

    let allTableRowsIds = [];
    allTableRows.data.forEach((element) => {
      allTableRowsIds.push(element.identification);
    });

    let selectedItemIds = [];
    selectedItem.forEach((element) => {
      selectedItemIds.push(element._id);
    });

    let difference = allTableRowsIds.filter(
      (x) => !selectedItemIds.includes(x)
    );

    for (let i = 0; i < allTableRows.data.length; i++) {
      for (let j = 0; j < difference.length; j++) {
        if (allTableRows.data[i].identification === difference[j]) {
          notLinkRow.push(allTableRows.data[i]);
        }
      }
    }

    if (notLinkRow.length > 0) {
      notLinkRow.forEach((item) => {
        let model = {
          children: [],
          name: item.name,
          id: item.name,
          isSubfolder: true,
          parentfolder: node.id,
        };
        roots.unshift(model);
      });
    }
    var pureTree = [...list, ...resultList];
    // return roots;
    resolve([roots, pureTree]);
  });
}
export async function budgetListToTree() {
  return new Promise(async function (resolve, reject) {
    var allTableRows = await getAllPlannigCheckTable(
      process.env.REACT_APP_CATALOG_BUDGET
    );
    var roots = [];
    if (allTableRows.data.length > 0) {
      allTableRows.data.forEach((item) => {
        let model = {
          children: [],
          name: item.name,
          id: item.name,
          isSubfolder: true,
          parentfolder: null,
        };
        roots.unshift(model);
      });
    }
    // return roots;
    resolve(roots);
  });
}
/**
 * *
 */
